module.exports = __webpack_public_path__ + "static/media/tv-internet-communication.a3edda02.svg";